'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = function (_Component) {
  (0, _inherits3.default)(Input, _Component);

  function Input(props) {
    (0, _classCallCheck3.default)(this, Input);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Input.__proto__ || (0, _getPrototypeOf2.default)(Input)).call(this, props));

    _this.onFocus = function (event) {
      var input = _this.props.input;

      _this.setState({ visited: true });

      if (input && input.onFocus) {
        input.onFocus(event);
      }
    };

    _this.className = function () {
      var _this$props = _this.props,
          success = _this$props.success,
          warning = _this$props.warning,
          error = _this$props.error,
          parentWidth = _this$props.parentWidth;

      return (0, _classnames2.default)({
        'quiver-input': true,
        'quiver-input--parent-width': parentWidth,
        'quiver-input--visited': _this.state.visited,
        'quiver-input--success': success,
        'quiver-input--warning': warning,
        'quiver-input--error': error
      });
    };

    _this.state = {
      visited: !!props.defaultValue || !!props.value
    };
    return _this;
  }

  (0, _createClass3.default)(Input, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.value || props.visited) {
        this.setState({
          visited: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          id = _props.id,
          defaultValue = _props.defaultValue,
          value = _props.value,
          label = _props.label,
          input = _props.input,
          message = _props.message,
          style = _props.style;


      return _react2.default.createElement(
        'div',
        { className: this.className(), style: style },
        _react2.default.createElement(
          'label',
          { htmlFor: id, style: style && style.label },
          label
        ),
        _react2.default.createElement('input', (0, _extends3.default)({}, input, {
          type: type,
          id: id,
          defaultValue: defaultValue,
          value: value,
          onFocus: this.onFocus,
          style: style && style.input
        })),
        message ? _react2.default.createElement(
          'div',
          { className: 'quiver-input__message', style: style && style.message },
          message
        ) : null
      );
    }
  }]);
  return Input;
}(_react.Component);

Input.propTypes = {
  type: _propTypes2.default.string,
  id: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  value: _propTypes2.default.string,
  label: _propTypes2.default.string,
  message: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  success: _propTypes2.default.bool,
  warning: _propTypes2.default.bool,
  parentWidth: _propTypes2.default.bool,
  input: _propTypes2.default.object,
  style: _propTypes2.default.object
};
exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/Input/Input.js
// module id = 592
// module chunks = 11